module.exports = __webpack_public_path__ + "media/images/placeholders/schulsozialdienst-3c75dc2d6f21d7f6ecf7c7d11b1ba70a.jpg";